import React from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
  Avatar,
  Card,
  CardContent,
  Paper,
} from '@mui/material';
import InMemory from '../components/In_Memory.jpg';
import Adesh from '../components/Adesh.jpg';
import RK from '../components/RK.jpg';
import AboutStatus from '../components/AboutStaus.jpg';
import Program_7 from '../assets/Program_7.jpg';
import Program_9 from '../assets/Program_9.jpg';
import Program_5 from '../assets/Program_5.jpg';
import Anoop from '../assets/ProfAnoop.jpg';
import Sunil from '../assets/MajSunilRai.jpg';
import Meeta from '../assets/MeetaSingh.jpg';
import MLJ from '../assets/MLJain.jpg';
import Padam from '../assets/PadamSingh.jpg';
import Arun from '../assets/ArunSingh.jpg';
import Abraham from '../assets/Abraham.jpg';
import Header from "../components/Header";
import Footer from '../components/Footer';
import Rakesh from '../assets/Heerawat.jpg';
import Madhu from '../assets/Madhu_Jain.jpg';


const team = [
  { name: 'Shri Rama Kant Chaturvedi',  
    description: 'Served Central government for 4 decades as trained & experienced engineer and dedicated to social development & environment protection',
    img: RK },
  { name: 'Prof. Dr. Adesh Chaturvedi', 
    description: 'Public Health Expert, Academician, Researchers, Program Management Expert with 28 years of experience',
    img: Adesh },
];

const About = () => {
  return (
      <div>
        <Header />
        <Box sx={{ fontFamily: 'sans-serif', py: 6 }}>
          {/* Our Story */}
          <Box
            sx={{
              bgcolor: '#e0f7fa',
              py: { xs: 5, md: 8 },
              px: { xs: 2, md: 8 },
              maxWidth: 'xl',
              justifyContent: 'center',
              margin: 'auto',
              borderRadius: 6,
              boxShadow: 3,
              my: 4,
            }}
          >
            <Container maxWidth="lg">
              <Typography
                variant="h4"
                fontWeight="bold"
                align="center"
                gutterBottom
                sx={{
                  color: 'black',
                  letterSpacing: 1,
                  mb: 3,
                  textShadow: '0 2px 8px rgba(21,101,192,0.08)',
                }}
              >
                About Samriddhi Trust
              </Typography>

              <Grid container spacing={4} alignItems="center" justifyContent="center">
                {/* Centered Image */}
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Box
                    component="img"
                    src={InMemory}
                    alt="Our Story"
                    sx={{
                      width: { xs: '90%', sm: '60%', md: '45%' },
                      borderRadius: 4,
                      boxShadow: 2,
                      mb: { xs: 2, md: 0 },
                      border: '4px solid #b3e5fc',
                    }}
                  />
                </Grid>

                {/* Text Content */}
                <Grid item xs={12}>
                  <Typography
                    variant="body1"
                    fontSize={{ xs: '1rem', md: '1.15rem' }}
                    sx={{
                      color: '#263238',
                      lineHeight: 1.8,
                      textAlign: 'justify',
                      background: 'rgba(255,255,255,0.85)',
                      borderRadius: 2,
                      p: { xs: 1, md: 3 },
                      boxShadow: 1,
                    }}
                  >
                    “Late Leelawati Chaturvedi Samriddhi Trust” popularly known as “SAMRIDDHI TRUST” is a non-profit public trust registered under
                    Trust Act (registration no. 2005000070 dated 1st Feb. 2005 and Darpan ID is: RJ/2025/0586557).  
                    The organization was established with two broad objectives: <br />
                    <b>a.</b> To provide support in improving health, economical, education, and living standard of the 
                    community by capacity building, community & resource mobilisation.  <br />
                    <b>b.</b> To provide support to various governments, trusts, corporate, international agencies in planning, 
                    documenting, developing, implementing, monitoring and evaluating the efforts for the welfare & development 
                    of the community and its sustainability.  <br /> <br /> 
                    It was created to stand in solidarity with poor and marginalized people, and support their efforts to take 
                    control of their own lives and fulfil their rights, responsibilities and aspirations. In a short span of time 
                    of two decades, it has emerged as a vibrant community development organization, dedicated to motivating and 
                    empowering the poor and vulnerable sections of the society.  <br /> <br /> 
                    Samriddhi has been working with community and opinion leaders, policy makers, and government staff to 
                    design and implement innovative and participatory projects in health, education, service provision 
                    and advocacy, providing models that can be adopted and expanded by government, corporate houses 
                    and other civil society organisations.  <br /> <br /> 
                    With multifaceted development interventions, Samriddhi strives to bring about positive changes in the 
                    quality of life of the poor people. It adopts following approaches to achieve the objectives 
                    and the need of the thrust areas-   <br />
                    <Box
                      component="ul"
                      sx={{
                        pl: 4,
                        mt: 2,
                        mb: 0,
                        color: '#1565c0',
                        fontWeight: 500,
                        fontSize: { xs: '1rem', md: '1.08rem' },
                        '& li': {
                          mb: 1,
                          lineHeight: 1.7,
                          listStyle: 'disc',
                        },
                      }}
                    >
                      <li>Community Mobilisation and Empowerment through behaviour change communication and capacity building.</li>
                      <li>Developing and implementing innovative approaches for low cost and efficient delivery of services for community development.</li>
                      <li>Training, Research, Monitoring and Evaluation.</li>
                      <li>Provide technical support to the business and industrial houses in implementing activities under corporate social responsibility.</li>
                      <li>Collaborating /networking with other government and non-government organizations to share resources and promote issues of concern.</li>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
            </Container>
          </Box>
          <Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Our Vision
            </Typography>
              <img src={AboutStatus} alt="Our Story" style={{ width: '100%', borderRadius: 8 }} />
            <Typography variant="body1" fontSize="1.3rem" fontWeight={600} sx={{ fontStyle: 'italic' }} >
              "Samriddhi family believes in empowering community by building their capacities and providing them
              opportunities for systematic and sustainable action."
            </Typography>
          </Container>

          {/* Meet Our Team */}
          <Box sx={{ bgcolor: '#e3f2fd', py: 8 }}>
            <Container maxWidth="lg">
              <Typography variant="h4" fontWeight="bold" align="center" gutterBottom>
                Managing Trustees
              </Typography>
              <Grid container spacing={6} justifyContent="center">
                {team.map((person, i) => (
                  <Grid item xs={12} sm={4} key={i} textAlign="center">
                    <Avatar
                      alt={person.name}
                      src={person.img}
                      sx={{ width: 120, height: 120, mx: 'auto', mb: 2 }}
                    />
                    <Typography variant="h6">{person.name}</Typography>
                    <Typography variant="body2" >{person.description}</Typography>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          {/* Our Advisors */}
          <Container maxWidth="md" sx={{ py: 8 }}>
            <Typography variant="h4" fontWeight="bold" align="center" gutterBottom>
              Our Advisors
            </Typography>
            <Box
              mt={4}
              display="flex"
              flexWrap="wrap"
              justifyContent="space-between"
              gap={2} // gap between rows
            >
              {[ // list of advisor data
                {
                  img: Padam,
                  name: "Prof. Dr. Padam Singh, PhD, MSC",
                  desc: "Medical Statistician, Demographer and Academician, Ex. Additional Director General, Indian Council of Medical Research and Ex. Member of National Statistical Commission. He is Advisor to Medanta – The Medicity multi-super specialty institute and Samriddhi Trust, Jaipur."
                },
                {
                  img: MLJ,
                  name: "Dr. M. L. Jain, MBBS, MD",
                  desc: "Retired Director, Health Department, Govt. of Rajasthan, Retired Director, State Institute of Health and Family Welfare, Retired Project Director, GAIN Project, IIHMR and Professor in Udaipur Medical College."
                },
                {
                  img: Sunil,
                  name: "Prof. Dr. Sunil Rai, PhD, BITS Pilani, M.Tech. IIT (Mumbai),",
                  desc: "Chancellor, UPES, Dehradun He is retired Naval Commander, Indian Navy. He served UPES, Dehradun, MIT, ADT University and Kaziranga University as Vice Chancellor. He was Director, Goa Institute of Management, SP Jain School of Management and Goa Shipyard."
                },
                {
                  img: Meeta,
                  name: "Dr. Major (Rtd) Meeta Singh, MBBS, MD",
                  desc: "Renowned Gender Expert (recipient of National Award from National Women Commission), Clinician by education, served Indian Army, and working on the issues related to gender, adolescent reproductive and sexual health, female feoticide, domestic violence, equality, discrimination since 30 years in Rajasthan, Haryana, MP and UP."
                },
                {
                  img: Arun,
                  name: "Dr. Arun Singh MBBS, MD",
                  desc: "Dr. Arun Singh is the Head of Department, Department of Neonatology, AIIMS, Jodhpur. He was the Head of Department, Neonatology IPGMER Kolkata. Chief Technical Advisor and Founder, Rastriya Bal Swasthya Karyakram, MoHFW, GoI, Technical Advisor, Department of Medical, Health and Family Welfare, Governments of Rajasthan, MP, Bihar, Telangana, Hyderabad "
                },
                {
                  img: Anoop,
                  name: "Professor Anoop Khanna, PhD, MSW",
                  desc: "He is distinguished Professor with IIHMR and John Hopkins University of Public Health. He is renowned researcher of Social Sciences, Public Health and Management."
                },
                {
                  img: Madhu,
                  name: "Prof. Dr. Madhu Jain PhD (Psychology)",
                  desc: "Retired Dean, Faculty of Arts & Professor of Psychology at Rajasthan University, Jaipur. Noteworthy researcher and academician."
                },
                {
                  img: Rakesh,
                  name: "Dr. Rakesh Hirawat, MBBS, MD",
                  desc: "Dr. Rakesh Hirawat, MBBS, is medical practitioner with Govt. of Rajasthan and involved into Clinical and Administrative activities. Has wide experience of Public Health, Clinical and Health Management."
                },
                {
                  img: Abraham,
                  name: "Abraham George",
                  desc: "Research Expert: 32 years of research, operations and M&E experience. Has significant understanding, knowledge, expertise and experience in the field of research, monitoring & evaluation, learning with various organizations."
                }
              ].map((advisor, index) => (
                <Paper
                  key={index}
                  elevation={2}
                  sx={{
                    p: 3,
                    width: {
                      xs: '100%',    // Full width on very small screens
                      sm: '48%',     // Two per row with spacing on small+ screens
                    },
                    boxSizing: 'border-box'
                  }}
                >
                  {advisor.img && (
                    <Avatar 
                      src={advisor.img}
                      sx={{ width: 80, height: 80, mb: 2 }}
                    />
                  )}

                  <Typography fontWeight="bold" mt={1}>
                    {advisor.name}
                  </Typography>
                  <Typography variant="body1" fontStyle="italic">
                    {advisor.desc}
                  </Typography>
                </Paper>
              ))}
            </Box>
          </Container>

          {/* Impact Stories */}
          <Box sx={{ bgcolor: '#e3f2fd', py: 8 }}>
            <Container maxWidth="lg">
              <Typography variant="h4" fontWeight="bold" align="center" gutterBottom>
                Impact Stories
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  gap: 4, // spacing between cards
                  mt: 4,
                }}
              >
                {[
                  {
                    img: Program_7,
                    text: 'Our educational initiatives have reached to children in rural areas, providing them with quality education and school supplies.',
                  },
                  {
                    img: Program_9,
                    text: "We have established women's cooperatives that have empowered women to gain financial independence through skill development.",
                  },
                  {
                    img: Program_5,
                    text: 'Our healthcare programs have provided essential medical services and awareness to thousands, improving community health outcomes.',
                  },
                ].map((story, idx) => (
                  <Card key={idx} sx={{ width: 320, display: 'flex', flexDirection: 'column' }}>
                    <img
                      src={story.img}
                      alt={`Impact ${idx + 1}`}
                      style={{ width: '100%', height: 200, objectFit: 'cover' }}
                    />
                    <CardContent>
                      <Typography variant="body1">{story.text}</Typography>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            </Container>
          </Box>          
        </Box>

          {/* Footer */}
        <Footer />
      </div> 
  );
};

export default About;
